import iconAboutSrc from '../assets/profile-drawer/icon-about.png';
import iconLogoutSrc from '../assets/profile-drawer/icon-logout.png';
import iconTermsSrc from '../assets/profile-drawer/icon-terms.png';
import iconTransactionsSrc from '../assets/profile-drawer/icon-transactions.png';
import {
  iconAboutLogoSrc,
  iconContestsSrc,
  iconMyReferralsMenuSrc,
  iconPrivacySrc,
} from '../assets/profile';
import { MY_REWARD_PATH, PRIVACY_PATH, REFERRALS_PATH, TERMS_PATH, TRANSACTIONS_PATH } from '../routes/paths';

export const ABOUT_US_URL = 'https://rapchik.app/';

export const PROFILE_MENU_SECTIONS = [
  {
    id: 'history',
    title: 'HISTORY',
    items: [
      {
        id: 'rewards',
        label: 'My Rewards',
        iconVariant: 'my-rewards',
        path: MY_REWARD_PATH,
        iconSize: 24,
      },
      {
        id: 'contests',
        label: 'Contests',
        icon: iconContestsSrc,
        iconSize: 24,
      },
      {
        id: 'transactions',
        label: 'Transactions',
        icon: iconTransactionsSrc,
        iconSize: 24,
        path: TRANSACTIONS_PATH,
      },
    ],
  },
  {
    id: 'general',
    title: 'GENERAL',
    items: [
      {
        id: 'referrals',
        label: 'My Referrals',
        icon: iconMyReferralsMenuSrc,
        iconSize: 24,
        path: REFERRALS_PATH,
      },
      {
        id: 'about',
        label: 'About Us',
        icon: iconAboutLogoSrc,
        iconSize: 24,
        externalUrl: ABOUT_US_URL,
      },
      {
        id: 'terms',
        label: 'Terms & Conditions',
        icon: iconTermsSrc,
        iconSize: 24,
        path: TERMS_PATH,
      },
      {
        id: 'privacy',
        label: 'Privacy Policy',
        icon: iconPrivacySrc,
        iconSize: 24,
        path: PRIVACY_PATH,
      },
      {
        id: 'logout',
        label: 'Logout',
        icon: iconLogoutSrc,
        action: 'logout',
        iconSize: 24,
      },
    ],
  },
];

/** Drawer quick menu — legacy subset */
export const PROFILE_DRAWER_ITEMS = [
  { id: 'rewards', label: 'My Rewards', iconVariant: 'my-rewards', path: MY_REWARD_PATH, iconSize: 24 },
  { id: 'transactions', label: 'Transactions', icon: iconTransactionsSrc, iconSize: 24, path: TRANSACTIONS_PATH },
  { id: 'referrals', label: 'Referrals', icon: iconMyReferralsMenuSrc, iconSize: 24, path: REFERRALS_PATH },
  { id: 'about', label: 'About Us', icon: iconAboutSrc, iconSize: 24, externalUrl: ABOUT_US_URL },
  { id: 'terms', label: 'Terms & Conditions', icon: iconTermsSrc, iconSize: 24, path: TERMS_PATH },
  { id: 'logout', label: 'Logout', icon: iconLogoutSrc, action: 'logout', iconSize: 24 },
];
